import {
  Box,
  Button,
  Checkbox,
  Dialog,
  FormControlLabel,
  IconButton,
  Stack,
  SwipeableDrawer,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { LoadingButton } from "@mui/lab";
import event_cancel from "../../assets/icons/preveiw_cancel.svg";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useAuthContext } from "src/auth/useAuthContext";
import postGenerateLink from "src/services/events/postGenerateLink";
import eventsAffiliateData from "src/services/events/getAffiliate";

export default function ForOthers({
  open,
  onClose,
  eventData,
  setStatus,
  setAffiliationData,
}) {
  const matches = useMediaQuery("(max-width:600px)");
  const { user, logout } = useAuthContext();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [othersData, setOthersData] = useState({
    customer_name: "",
    customer_phone: "",
    customer_email: "",
    event: "",
    eventName: "new eve",
  });

  const [checkState, setCheckState] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const data = {
      customer_name: othersData?.customer_name,
      customer_email: othersData?.customer_email,
      customer_phone: othersData?.customer_phone,
      event: eventData?._id,
      eventName: eventData?.name,
    };
    const response = await postGenerateLink(user, data, logout);
    setIsSubmitting(false);
    if (response) {
      enqueueSnackbar("Generate Link Success Fully", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      onClose();
      setStatus(true);
      const response = await eventsAffiliateData(user, eventData?._id, logout);
      setAffiliationData(response);
      setStatus(false);
      setOthersData({
        customer_name: "",
        customer_phone: "",
        customer_email: "",
        event: "",
        eventName: "new eve",
      });
    }
  };

  const handleData = (key, value) => {
    setOthersData((prev) => {
      const data = { ...prev };
      data[key] = value;
      return data;
    });
  };
  return (
    <>
      {matches ? (
        <SwipeableDrawer anchor="bottom" open={open} onClose={onClose}>
          <Stack width="100%" spacing={2} p="1rem 1rem">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack spacing={1}>
                <Typography color="primary" variant="h3">
                  Generate New Link
                </Typography>
                <Typography variant="body2">
                  The link will be sent to email/phone no added below
                </Typography>
              </Stack>
              <IconButton onClick={onClose}>
                <Box component="img" src={event_cancel} />
              </IconButton>
            </Stack>
            <Stack spacing={2}>
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <Stack spacing={1}>
                    <Typography variant="subtitle2">Name</Typography>
                    <TextField
                      placeholder="abc"
                      name="customer_name"
                      value={othersData?.customer_name}
                      onChange={(e) =>
                        handleData(e.target.name, e.target.value)
                      }
                    />
                  </Stack>
                  <Stack
                    sx={{
                      border: "1px solid lightgray",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={() => {
                            setCheckState(!checkState);
                          }}
                        />
                      }
                      label="Send link as SMS/ Email"
                    />

                    {checkState && (
                      <>
                        <Stack spacing={1}>
                          <Typography variant="subtitle2">Phone</Typography>
                          <TextField
                            placeholder="123"
                            inputProps={{
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                              maxLength: 10,
                              onInput: (e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                              },
                            }}
                            value={othersData?.customer_phone}
                            onChange={(e) =>
                              handleData(e.target.name, e.target.value)
                            }
                            name="customer_phone"
                          />
                        </Stack>
                        <Stack spacing={1}>
                          <Typography variant="subtitle2">Email</Typography>

                          <TextField
                            placeholder="abc@gmail.com"
                            type="email"
                            name="customer_email"
                            value={othersData?.customer_email}
                            required={checkState}
                            onChange={(e) =>
                              handleData(e.target.name, e.target.value)
                            }
                          />
                        </Stack>
                      </>
                    )}
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  spacing={2}
                  pt={2}
                >
                  <Button variant="outlined" onClick={onClose} size="medium">
                    Cancel
                  </Button>

                  <LoadingButton
                    loading={isSubmitting}
                    type="submit"
                    size="medium"
                    variant="contained"
                  >
                    Generate
                  </LoadingButton>
                </Stack>
              </form>
            </Stack>
          </Stack>
        </SwipeableDrawer>
      ) : (
        <Dialog open={open}>
          <Stack width="100%" spacing={2} p="1rem 1rem">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack spacing={1}>
                <Typography color="primary" variant="h3">
                  Generate New Link
                </Typography>
                <Typography variant="body2">
                  The link will be sent to email/phone no added below
                </Typography>
              </Stack>
              <IconButton onClick={onClose}>
                <Box component="img" src={event_cancel} />
              </IconButton>
            </Stack>
            <Stack spacing={2}>
              <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <Stack spacing={1}>
                    <Typography variant="subtitle2">Name</Typography>
                    <TextField
                      placeholder="abc"
                      name="customer_name"
                      value={othersData?.customer_name}
                      onChange={(e) =>
                        handleData(e.target.name, e.target.value)
                      }
                    />
                  </Stack>
                  <Stack
                    sx={{
                      border: "1px solid lightgray",
                      borderRadius: "4px",
                      padding: "10px",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          onClick={() => {
                            setCheckState(!checkState);
                          }}
                        />
                      }
                      label="Send link as SMS/ Email"
                    />

                    {checkState && (
                      <>
                        <Stack spacing={1}>
                          <Typography variant="subtitle2">Email</Typography>

                          <TextField
                            placeholder="abc@gmail.com"
                            type="email"
                            name="customer_email"
                            value={othersData?.customer_email}
                            required={checkState}
                            onChange={(e) =>
                              handleData(e.target.name, e.target.value)
                            }
                          />
                        </Stack>
                        <Stack spacing={1}>
                          <Typography variant="subtitle2">Phone</Typography>
                          <TextField
                            placeholder="123"
                            inputProps={{
                              inputMode: "numeric",
                              pattern: "[0-9]*",
                              maxLength: 10,
                              onInput: (e) => {
                                e.target.value = e.target.value.replace(
                                  /[^0-9]/g,
                                  ""
                                );
                              },
                            }}
                            value={othersData?.customer_phone}
                            onChange={(e) =>
                              handleData(e.target.name, e.target.value)
                            }
                            name="customer_phone"
                          />
                        </Stack>
                      </>
                    )}
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  sx={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  spacing={2}
                  pt={2}
                >
                  <Button variant="outlined" onClick={onClose} size="medium">
                    Cancel
                  </Button>

                  <LoadingButton
                    loading={isSubmitting}
                    type="submit"
                    size="medium"
                    variant="contained"
                  >
                    Generate
                  </LoadingButton>
                </Stack>
              </form>
            </Stack>
          </Stack>
        </Dialog>
      )}
    </>
  );
}
